export default __webpack_public_path__ + "static/media/usa.33ab9026.jpg";